export const isGroupIdsSelected = (searchQuery) =>
  !!searchQuery?.rules?.filter(
    (rule) => rule.field === 'groupIds' && rule[rule.valueSource]?.length
  ).length
